import { Tabs } from "antd";
import SalesOrderEntry from "./Sales Order Entry/SalesOrderEntry";
import SalesOrderRecord from "./SalesOrderRecord";
import SalesOrderVoucher from "./SalesOrderVoucher";
import { useLocation, useNavigate  } from "react-router-dom";
import { accessChecker } from "../../../lib/functions";


const SalesOrder = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "entry";

  const handleTabChange = (key) => {
    navigate({
      pathname: location.pathname,
      search: `?tab=${key}`,
    });
  };

  const menuData = [
    {
      label: "Sales Order Entry",
      key: "entry",
      value: "sales_order_entry",
      children: (
        <>
          <SalesOrderEntry />
        </>
      ),
    },
    {
      label: "Sales Order Record",
      key: "record",
      value: "sales_order_record",
      children: (
        <>
          <SalesOrderRecord />
        </>
      ),
    },
    {
      label: "Sales Order Voucher",
      key: "voucher",
      value: "sales_order_voucher",
      children: (
        <>
          <SalesOrderVoucher />
        </>
      ),
    },
  ];

  const filteredMenuData = menuData.filter((menuItem) => accessChecker(menuItem.value));

  return (
    <Tabs
      activeKey={activeTab}
      onChange={handleTabChange}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={filteredMenuData}
    />
  );
};

export default SalesOrder;
